import services from '@/http'
import * as types from './mutation-types'

/**
 * Busca os dados do termo por token
 *
 * @param {Object} context - Contexto do Vuex
 * @param {string} token - Token de acesso ao termo
 */
export const ActionFetchByToken = async ({ commit }, token) => {
    commit(types.SET_LOADING, true)
    commit(types.SET_ERROR, null)

    try {
        const response = await services.showByToken({ token })
        const data = response.body.data || response.body

        const signature = data.signature || data
        
        commit(types.SET_SIGNATURE, signature)
        commit(types.SET_CONTENT, data.content || signature.content)
        commit(types.SET_TERM, data.term || signature.term)
        commit(types.SET_TEACHER, data.teacher || signature.teacher)
        commit(types.SET_INSTITUTION, data.institution || signature.institution)

        return data
    } catch (error) {
        const errorData = error.body || error
        commit(types.SET_ERROR, {
            code: errorData.code || errorData.error?.code || 'UNKNOWN_ERROR',
            message: errorData.message || errorData.error?.message || 'Erro ao carregar o termo'
        })
        throw errorData
    } finally {
        commit(types.SET_LOADING, false)
    }
}

/**
 * Assina o termo usando o token
 *
 * @param {Object} context - Contexto do Vuex
 * @param {Object} payload - Dados para assinatura
 * @param {string} payload.token - Token de acesso
 * @param {boolean} payload.agree - Concordância (termos obrigatórios)
 * @param {number} payload.term_option_id - ID da opção (termos com opções)
 */
export const ActionSignByToken = async ({ commit }, { token, agree, term_option_id }) => {
    commit(types.SET_LOADING, true)
    commit(types.SET_ERROR, null)

    try {
        const response = await services.signByToken({ token }, {
            agree,
            term_option_id
        })
        const data = response.body.data || response.body

        // Atualizar a assinatura no state após assinar
        commit(types.SET_SIGNATURE, data.signature || data)

        return data
    } catch (error) {
        const errorData = error.body || error
        commit(types.SET_ERROR, {
            code: errorData.code || 'SIGN_ERROR',
            message: errorData.message || 'Erro ao assinar o termo'
        })
        throw errorData
    } finally {
        commit(types.SET_LOADING, false)
    }
}

/**
 * Limpa o estado do módulo
 */
export const ActionResetState = ({ commit }) => {
    commit(types.RESET_STATE)
}
